/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import Load from '../../components/Load';
import NavBar from '../../components/NavBar';

import { getToken } from '../../api/auth';

import { FieldActivityCreateFetch } from '../../api/services/NotebookAPI';
import { PlotsFetch } from '../../api/services/PropertyAPI';

export default function FieldActivityCreate({ history }) {
  const token = getToken();

  const [plots, setPlots] = useState([]);
  const [plotSelected, setPlotSelected] = useState({ name: '' });
  const [activity, setActivity] = useState('');
  const [observation, setObservation] = useState('');
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getPlots() {
      setIsLoad(true);
      try {
        const resultPlots = await PlotsFetch(token);
        console.log('getPlots | resultPlots: ', resultPlots);
        setIsLoad(false);
        setMessageWarning(resultPlots.message);
        if (resultPlots.isSuccess) {
          setPlots(resultPlots.plots);
          if ((resultPlots.plots).length >= 1) {
            setPlotSelected(resultPlots.plots[0]);
          }
        }
      } catch (error) {
        console.log('getPlots | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getPlots();
  }, [history, token]);

  async function sendFieldActivityCreate(event) {
    event.preventDefault();
    try {
      setIsLoad(true);
      if (plotSelected.name === '') {
        setMessageWarning('selecione um talhão');
        setIsSuccessMessage(false);
        setIsLoad(false);
      } else if (!activity) {
        setMessageWarning('preencha o campo atividade');
        setIsSuccessMessage(false);
        setIsLoad(false);
      } else {
        const resultFieldActivityCreate = await FieldActivityCreateFetch(
          token,
          activity,
          observation,
          plotSelected.name,
        );
        console.log('sendFieldActivityCreate | resultFieldActivityCreate', resultFieldActivityCreate);
        setIsLoad(false);
        setIsSuccessMessage(resultFieldActivityCreate.isSuccess);
        setMessageWarning(resultFieldActivityCreate.message);
      }
    } catch (error) {
      console.log('sendFieldActivityCreate | error', error);
      setIsSuccessMessage(false);
      setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
      setIsLoad(false);
    }
  }

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Registrar Atividade
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          {!isSuccessMessage
            ? (
              <>
                <div className="label__container">
                  <p className="form__label">
                    Talhão *
                  </p>
                </div>
                <select
                  className="form__select"
                  value={plotSelected.name}
                  onChange={(event) => {
                    console.log(event.target.value);
                    function isPlot(plot) {
                      return plot.name === event.target.value;
                    }
                    const plotFound = plots.find(isPlot);
                    console.log('plotFound: ', event.target.value);
                    setPlotSelected(plotFound);
                  }}
                >
                  {
                    plots.map((plot) => (
                      <option value={plot.name} key={plot.name}>{plot.name}</option>
                    ))
                  }
                </select>

                <div className="label__container">
                  <p className="form__label">
                    Atividade *
                  </p>
                </div>
                <input
                  className="form__input"
                  type="text"
                  placeholder="Digite aqui a atividade"
                  value={activity}
                  onChange={(event) => setActivity(event.target.value)}
                />

                <div className="label__container">
                  <p className="form__label">
                    Observação
                  </p>
                </div>
                <input
                  className="form__input"
                  type="text"
                  placeholder="Digite aqui a observação"
                  value={observation}
                  onChange={(event) => setObservation(event.target.value)}
                />

                <button
                  className="form__button"
                  type="button"
                  onClick={(event) => sendFieldActivityCreate(event)}
                >
                  Resgistrar
                </button>
              </>
            ) : null }

          {isSuccessMessage && messageWarning
            ? (
              <button
                className="form__button"
                type="button"
                onClick={() => navigate('/notebook/field-activity', { replace: true })}
              >
                Ir para atividades
              </button>
            ) : null }
        </div>
      </div>
    </>
  );
}
